<template>
  <v-list dense>
    <v-list-tile to="/">
      <v-list-tile-action>
        <v-icon>fa-tachometer-alt</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $t('message.dashboard') }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile :to="{ name: 'users' }">
      <v-list-tile-action>
        <v-icon>fa-users</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $t('message.users') }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile :to="{ name: 'indicatorslist' }">
      <v-list-tile-action>
        <v-badge color="red" :value="indicatorsForApproval > 0">
          <template v-slot:badge>
            <span>{{ indicatorsForApproval }}</span>
          </template>
          <v-icon>fa-clipboard-list</v-icon>
        </v-badge>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          {{ $t('message.indicator_list') }}
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile :to="{ name: 'targetslist' }">
      <v-list-tile-action>
        <v-badge color="red" :value="targetsForApproval > 0">
          <template v-slot:badge>
            <span>{{ targetsForApproval }}</span>
          </template>
          <v-icon>fa-bullseye</v-icon>
        </v-badge>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $t('message.targets') }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile :to="{ name: 'standardvalues' }">
      <v-list-tile-action>
        <v-icon>fa-chart-line</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          {{ $t('message.standard_values_title') }}
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile :to="{ name: 'rollingvalues' }">
      <v-list-tile-action>
        <v-icon>fa-euro-sign</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          {{ $t('message.rolling_values_title') }}
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile :to="{ name: 'averagevalues' }">
      <v-list-tile-action>
        <v-icon>fa-divide</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          {{ $t('message.average_values_title') }}
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile href="/forum">
      <v-list-tile-action>
        <v-icon>fa-comments</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $t('message.forum') }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile href="https://omdatlevensduurloont.nl" target="_blank">
      <v-list-tile-action>
        <v-icon>fa-book-open</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $t('message.manual') }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'UserMenu',
  computed: {
    ...mapState(['targetsForApproval', 'indicatorsForApproval']),
  },
  created() {
    this.$store.dispatch('getItemsForApproval')
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
    },
  },
}
</script>
